import { SVGProps, Ref, forwardRef } from 'react';

export const DashedSquareOutOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path d="M10 2.4h3.6V6H15V1h-5z" fill="currentColor" />
                <path d="M6 2.4V1H1v5h1.4V2.4z" fill="currentColor" />
                <path d="M2.4 10H1v5h5v-1.4H2.4z" fill="currentColor" />
                <path d="M10 13.6V15h5v-5h-1.4v3.6z" fill="currentColor" />
            </g>
        </svg>
    )
);
DashedSquareOutOutlinedSize16Glyph.displayName = 'DashedSquareOutOutlinedSize16Glyph';
